import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import Dropzone from "react-dropzone";
import { Card, CardHeader, CardText, CardBody } from "reactstrap";
import { service as cpoService } from "../redux";
import { DjangoForm } from "../../../neo_importer";
import * as _ from "lodash";

class CPOUploader extends Component {
    state = {
        file: null,
        errorMessage: null,
        successMessage: null,
        extraFields: null,
        loading: false,
        error: null,
    };

    componentWillMount() {
        this.getUploaderData();
    }

    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "cpo_upload",
            title: "Customer purchase order file uploader",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Customer purchase order file uploader" }],
            loading: this.state.loading,
            extraProps,
            style: { heigth: "100%" }
        };
        const zoneStyle = {
            width: "100%",
            height: 150,
            border: "2px dashed #888",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        };
        return (
            <Base {...base_op}>
                <div className="row">
                    {this.state.errorMessage ? (
                        <div className="col-md-12">
                            <div
                                className="alert alert-danger"
                                dangerouslySetInnerHTML={{
                                    __html: this.state.errorMessage
                                }}
                            />
                        </div>
                    ) : null}
                    {this.state.successMessage ? (
                        <div className="col-md-12">
                            <div
                                className="alert alert-success"
                                dangerouslySetInnerHTML={{
                                    __html: this.state.successMessage
                                }}
                            />
                        </div>
                    ) : null}
                    {this.state.file ? (
                        <div className="col-md-12">
                            <div
                                className="alert alert-success"
                                dangerouslySetInnerHTML={{
                                    __html: this.state.file.name
                                }}
                            />
                        </div>
                    ) : null}
                    <div className="col-md-9">
                        <Dropzone
                            disableClick
                            accept=".pdf"
                            multiple={false}
                            style={zoneStyle}
                            onDrop={this.onDrop}
                            onFileDialogCancel={this.onCancel}
                        >
                            {({ isDragActive, isDragReject, open }) => {
                                if (isDragActive) {
                                    return <p>File accepted</p>;
                                }
                                if (isDragReject) {
                                    return <p>Files rejected</p>;
                                }
                                return (
                                    <React.Fragment>
                                        <p>Dropping file here ... or</p>
                                        <button className="btn btn-primary" type="button" onClick={() => open()}>
                                            Browse File
                                        </button>
                                    </React.Fragment>
                                );
                            }}
                        </Dropzone>
                        <br />
                        {this.state.extraFields && <DjangoForm ref="djangoForm" fields={this.state.extraFields} />}
                        {<small className="text-danger form-text">{this.state.error}</small>}
                        <button
                            disabled={this.state.file ? "" : "disabled"}
                            className="btn btn-primary float-right"
                            onClick={this.onSubmit}
                        >
                            Import File
                        </button>
                    </div>
                    <div className="col-md-3">
                        <Card>
                            <CardHeader className="bg-primary text-white">
                                Customer purchase order importer rules
                            </CardHeader>
                            <CardBody>
                                <CardText>
                                    Customer purchase order importer is usefull to upload your own CPOs without waiting
                                    to be imported by the system through the email. You must follow next rules:
                                    <br />
                                </CardText>
                                <ul>
                                    <li>Importer only will work with valid PDFs files</li>
                                    <li>Only one PDF at the time</li>
                                </ul>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </Base>
        );
    }

    getUploaderData = () => {
        this.setState({ loading: true });
        cpoService.getCpoUpload().then(response =>
            this.setState({
                loading: false,
                extraFields: response.form_api.ordered_fields
                    .filter(field => field !== "uploaded_file")
                    .map(key => {
                        const res = { ...response.form_api.fields[key] };
                        res["key"] = key;
                        return res;
                    })
            })
        );
    };

    onDrop = files => {
        const newFile = files[0];
        this.setState({ file: newFile, errorMessage: null, successMessage: null });
    };

    onCancel = () => {
        this.setState({ file: null, errorMessage: null });
    };

    onSubmit = () => {
        const { values } = this.refs.djangoForm;
        if (!values.customer_team) {
            this.setState({ error: 'This field is required' })
            return
        }
        const customer_team = values.customer_team ? values.customer_team : 82; // default customer team for india
        cpoService.uploadCPOFile(this.state.file, customer_team).then(response => {
            if (_.has(response, "error")) {
                this.setState({
                    errorMessage: response.error,
                    file: null,
                    successMessage: ""
                });
            } else {
                this.setState({
                    file: null,
                    successMessage:
                        "Your file have been successfuly uploaded, Our system will read and add a new customer purchase order shortly",
                    errorMessage: ""
                });
            }
        });
    };
}

export default CPOUploader;
